export default __webpack_public_path__ + "static/media/file-type.586583f1.svg";